import React from 'react';
import {Icon} from '@iconify/react';
import TooltipWrapper from '../../../ui/components/common/TooltipWrapper';
import {randomString} from '../../../utils/utils';
import {TOOLTIP_DELAY} from '../../../constants';
import './checklistTile.scss';
import Label from '../label/Label';

interface ChecklistTileProps {
    value: boolean;
    label: string;
    help?: string;
    color?: 'info' | 'warning' | 'error' | 'secondary' | 'primary';
    onChange: (value: boolean) => void;
    disabled?: boolean;
}

function ChecklistTile({value, label, help, color = 'secondary', onChange, disabled}: ChecklistTileProps): JSX.Element {
    return (
        <TooltipWrapper hide={!help} className="c-checklistTile__help" id={randomString(10)} delayShow={TOOLTIP_DELAY} content={help || ''}>
            <div
                className={`c-checklistTile ${value ? 'c-checklistTile--checked' : ''} ${disabled ? 'c-checklistTile--disabled' : ''}`}
                data-testid="checklistTile"
            >
                <div className="c-checklistTile__input" onClick={() => !disabled && onChange(!value)}>
                    <Icon
                        className={`c-checklistTile__input_checkbox c-checklistTile__input_checkbox--${color}`}
                        icon={value ? 'solar:check-square-bold' : 'solar:stop-linear'}
                    />
                    <Label>{label}</Label>
                </div>
            </div>
        </TooltipWrapper>
    );
}

export default ChecklistTile;
